import React, { useState, useEffect } from "react";
import { deleteHolidayPackages, getAllHolidayPackages } from "../../services/authServices";
import { Container, Row, Table } from "react-bootstrap";
import moment from "moment";
import MainTitle from "../../components/mainTitile/mainTitle";
import HolidaysDataModal from "../../components/holidaysData/holidaysDataModal";
import {FiEdit} from 'react-icons/fi'
import { AiFillDelete } from "react-icons/ai";
import TablePagination from "../../components/pagination/tablePagination";

const Holidays = () => {
  const [holidayData, setHolidayData] = useState([]);
  const [holidayModalShow, setHolidayModalShow] = useState(false);
  const [holidayId, setHolidayId] = useState();
  const getAllHolidayData = () => {
    let params = {
    page,
    limit : pageData
    }
    getAllHolidayPackages(params)
      .then((res) => {
        setHolidayData(res.data.Data.getData);
        setPageCount(res.data.Data.totalCount);
        console.warn("holiday data from api response", res.data.Data.totalCount);
      })
      .catch((err) => {
        console.warn("holiday data from api Error", err);
      });
  };

  const handleEdit = (data) =>{
    setHolidayId(data?.holidayId)
    setHolidayModalShow(true)
    }

    const deleteHolidataData = (id) =>{
      deleteHolidayPackages(id).then((res)=>{
        getAllHolidayData()
      }).catch((err)=>{
      console.log(err);
      })
    }

  useEffect(() => {
    getAllHolidayData();
  }, [!holidayModalShow,HolidaysDataModal]);


  // pagination for holiday packages...
  
  const [pageCount, setPageCount] = useState(0);
  const [pageData, setPageData] = useState(10);
  const [page, setPage] = useState(1);

  useEffect(() => {
    getAllHolidayData()
  }, [page, pageData]);

  useEffect(() => {
    const pagedatacount = Math.ceil(pageCount / pageData);
    setPageCount(pagedatacount);
  }, [holidayData]);

  const handleRowSize = (e) => {
    const { innerHTML } = e.target;
    setPageData(innerHTML);
    console.log("row per page size", innerHTML);
  };


  return (
    <>
      <Container>
      <Row>

      <MainTitle heading={"Holiday pakages"} textAlign={"center"} />
      </Row>
      <Row>
        <Table bordered hover responsive>
          <thead className="fs-14 fw-700">
            <tr className="text-capitalize">
              <th>HP Order Id</th>
              <th>first name</th>
              <th>From</th>
              <th>mobile</th>
              <th> to</th>
              <th>start Date</th>
              <th>End date</th>
              <th>No. Of nights</th>
              <th>status</th>
              <th colSpan={2} className="text-center">Action</th>
            </tr>
          </thead>
          <tbody className="fs-12">
            {holidayData?.map((i, ind) => {
            let params ={ holidayId : i?.holidayId};
              return (
                <>
                  <tr className="text-capitalize">
                    <td>{i.holidayId}</td>
                    <td>{i.firstname}</td>
                    <td>{i.from}</td>
                    <td>{i.to}</td>
                    <td>{i.mobile}</td>
                    <td>{moment(i.fromDate).format("DD MMM  YYYY")}</td>
                    <td>{moment(i.toDate).format("DD MMM YYYY")}</td>
                    <td>{i.number_Nights}</td>
                    <td>{i.status}</td>
                    <td> <a style={{cursor:'pointer'}} onClick={()=>handleEdit(i)}>  <FiEdit color="green" size={15}/> </a></td>
                    <td>  <AiFillDelete color="red" onClick={()=>deleteHolidataData(i?.holidayId)} style={{cursor:'pointer'}} size={20}  /></td>
                    {/* <td>  <AiFillDelete color="red" onClick={()=>deleteHolidayPackages(params)} style={{cursor:'pointer'}} size={20}  /></td> */}
                  </tr>
                </>
              );
            })}
          </tbody>


        </Table>
          {pageCount > 1 && 
          <TablePagination handleRowSize={handleRowSize} setPage={setPage} page={page} pageData={pageData} pageCount={pageCount} />
          }
        </Row>
      </Container>
      <HolidaysDataModal  handleCloseModal={()=>setHolidayModalShow(false)} show={holidayModalShow} holidayId={holidayId} />
    </>
  );
};

export default Holidays;
